import { render } from "./LayoutSystem.vue?vue&type=template&id=19175236"
import script from "./LayoutSystem.vue?vue&type=script&lang=ts"
export * from "./LayoutSystem.vue?vue&type=script&lang=ts"

import "./LayoutSystem.vue?vue&type=style&index=0&id=19175236&lang=scss"
script.render = render

export default script